<div class="employees-page">
  <app-header
    [title]="'TITLES.TEAM' | translate"
    [subtitle]="'COMPONENTS.EMPLOYEES.SUBTITLE' | translate"
  >
    <div header-actions class="employees-page__header-actions">
      <div class="hidden lg:block">
        <app-navbar-profile-info></app-navbar-profile-info>
      </div>
    </div>
  </app-header>

  <div class="employees-page__content px-4 md:px-8 py-6 md:py-8">
    @if (pageStats$ | async; as stats) {
      <section class="employees-page__top-row" aria-label="Employees statistics">
        <div class="employees-page__stats-shell">
          <div class="employees-page__stats">
            <app-card-shell class="employees-stat-card" padding="md">
              <p class="employees-stat-card__label">
                {{ "COMPONENTS.EMPLOYEES.STATS.MEMBERS" | translate }}
              </p>
              <p class="employees-stat-card__value">{{ stats.membersCount }}</p>
            </app-card-shell>

            <app-card-shell class="employees-stat-card employees-stat-card--online" padding="md">
              <p class="employees-stat-card__label">
                {{ "COMPONENTS.EMPLOYEES.STATS.ONLINE" | translate }}
              </p>
              <p class="employees-stat-card__value">{{ stats.onlineCount }}</p>
            </app-card-shell>

            <app-card-shell class="employees-stat-card employees-stat-card--invited" padding="md">
              <p class="employees-stat-card__label">
                {{ "COMPONENTS.EMPLOYEES.STATS.INVITED" | translate }}
              </p>
              <p class="employees-stat-card__value">{{ stats.invitedCount }}</p>
            </app-card-shell>

            <app-card-shell class="employees-stat-card employees-stat-card--rejected" padding="md">
              <p class="employees-stat-card__label">
                {{ "COMPONENTS.EMPLOYEES.STATS.REJECTED" | translate }}
              </p>
              <p class="employees-stat-card__value">{{ stats.rejectedCount }}</p>
            </app-card-shell>
          </div>
        </div>
        @if (canManageEmployees$ | async) {
          <button
            type="button"
            class="employees-page__invite-inline add-project-button"
            [ngbTooltip]="
              (canAddEmployee$ | async) === false
                ? ('TOOLTIPS.LIMIT_REACHED'
                  | translate: { entity: employeeLimitParam[currentLang] })
                : ''
            "
            [disabled]="(canAddEmployee$ | async) === false"
            (click)="openInviteModal()"
          >
            + {{ "BUTTONS.INVITE" | translate }}
          </button>
        }
      </section>
    }

    <div class="employees-layout">
      <section class="employees-main">
        <div class="employees-section-title">
          <h2>{{ "COMPONENTS.EMPLOYEES.SECTIONS.MEMBERS" | translate }}</h2>
        </div>

        <div class="employees-grid">
          @for (employee of employeeCards$ | async; track employee.id) {
            <article
              class="employee-card"
              tabindex="0"
              (click)="viewProfile(employee.id, employee.role)"
              (keydown.enter)="viewProfile(employee.id, employee.role)"
            >
              <div class="employee-card__header">
                <div class="employee-card__identity">
                  <div class="employee-card__avatar">
                    <div
                      class="employee-card__avatar-media"
                      [class.employee-card__avatar-media--placeholder]="!employee.hasImage"
                    >
                      @if (employee.hasImage) {
                        <img [src]="employee.imageUrl" [alt]="employee.displayName" />
                      } @else {
                        <span>{{ employee.initials }}</span>
                      }
                    </div>

                    <span
                      class="employee-card__presence"
                      [class.employee-card__presence--online]="employee.isOnline"
                    ></span>
                  </div>

                  <div class="employee-card__meta">
                    <p class="employee-card__name">{{ employee.displayName }}</p>
                    <p class="employee-card__role">{{ employee.roleLabelKey | translate }}</p>
                  </div>
                </div>

              </div>

              <div class="employee-card__details">
                <div class="employee-card__detail-row">
                  <div
                    class="employee-card__detail-icon"
                    [ngbTooltip]="'TABLE_HEADERS.EMAIL' | translate"
                    [attr.aria-label]="'TABLE_HEADERS.EMAIL' | translate"
                  >
                    <svg viewBox="0 0 20 20" fill="none">
                      <path
                        d="M3.333 5.833A1.667 1.667 0 0 1 5 4.167h10A1.667 1.667 0 0 1 16.667 5.833v8.334A1.667 1.667 0 0 1 15 15.833H5a1.667 1.667 0 0 1-1.667-1.666V5.833Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                      />
                      <path
                        d="m4.167 6.25 5.243 3.67a1 1 0 0 0 1.18 0l5.243-3.67"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="employee-card__detail-content">
                    <span
                      class="employee-card__detail-value"
                      [title]="employee.hasEmail ? employee.email : null"
                    >
                      {{ employee.email }}
                    </span>
                  </div>
                </div>

                <div class="employee-card__detail-row">
                  <div
                    class="employee-card__detail-icon"
                    [ngbTooltip]="'TABLE_HEADERS.PHONE_NUMBER' | translate"
                    [attr.aria-label]="'TABLE_HEADERS.PHONE_NUMBER' | translate"
                  >
                    <svg viewBox="0 0 20 20" fill="none">
                      <path
                        d="M5.608 3.333h2.017c.387 0 .726.261.824.635l.662 2.529a.833.833 0 0 1-.24.816l-1.477 1.327a11.7 11.7 0 0 0 3.966 3.966l1.327-1.478a.833.833 0 0 1 .816-.239l2.53.662a.853.853 0 0 1 .634.823v2.017a1.667 1.667 0 0 1-1.667 1.667h-.833C8.614 16.667 3.333 11.386 3.333 4.167v-.834a1.667 1.667 0 0 1 1.667-1.667Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="employee-card__detail-content">
                    <span class="employee-card__detail-value" [title]="employee.phoneNumber || null">
                      {{ employee.phoneNumber }}
                    </span>
                  </div>
                </div>

                <div class="employee-card__detail-row">
                  <div
                    class="employee-card__detail-icon"
                    [ngbTooltip]="'COMPONENTS.EMPLOYEES.CARD.JOINED' | translate"
                    [attr.aria-label]="'COMPONENTS.EMPLOYEES.CARD.JOINED' | translate"
                  >
                    <svg viewBox="0 0 20 20" fill="none">
                      <path
                        d="M6.667 1.667v2.5m6.666-2.5v2.5M3.75 6.25h12.5m-10.833-3.75h9.166A1.667 1.667 0 0 1 16.25 4.167V15a1.667 1.667 0 0 1-1.667 1.667H5.417A1.667 1.667 0 0 1 3.75 15V4.167A1.667 1.667 0 0 1 5.417 2.5Z"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="employee-card__detail-content">
                    <span class="employee-card__detail-value" [title]="employee.joinedAt || null">
                      {{ employee.joinedAt }}
                    </span>
                  </div>
                </div>
              </div>
            </article>
          }
        </div>
      </section>

      @if (inviteSidebarView$ | async; as inviteSidebar) {
        @if (inviteSidebar.shouldShowSidebar) {
          <aside class="employees-sidebar">
            <app-card-shell class="employees-sidebar__card" padding="md">
              <div class="employees-sidebar__header">
                <div>
                  <h2>{{ "COMPONENTS.EMPLOYEES.SECTIONS.INVITATIONS" | translate }}</h2>
                </div>

                <div class="employees-sidebar__header-meta">
                  <button
                    id="expand-collapse-button"
                    type="button"
                    class="employees-sidebar__collapse"
                    [class.employees-sidebar__collapse--collapsed]="isCollapsed"
                    [attr.aria-expanded]="!isCollapsed"
                    (click)="toggleCollapsed()"
                  >
                    <svg viewBox="0 0 20 20" fill="none">
                      <path
                        d="m5 7.5 5 5 5-5"
                        stroke="currentColor"
                        stroke-width="1.8"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>

              <div
                class="employees-sidebar__list"
                [class.employees-sidebar__list--collapsed]="isCollapsed"
              >
                @if (inviteSidebar.inviteCards.length > 0) {
                  @for (invite of inviteSidebar.inviteCards; track invite.id) {
                    <article class="invite-card">
                      <div class="invite-card__content">
                        <p class="invite-card__email" [title]="invite.recipientEmail">
                          {{ invite.recipientEmail }}
                        </p>
                        <span
                          class="invite-card__status"
                          [class.invite-card__status--sent]="invite.status === inviteStatuses.Sent"
                          [class.invite-card__status--accepted]="invite.status === inviteStatuses.Accepted"
                          [class.invite-card__status--rejected]="invite.status === inviteStatuses.Rejected"
                        >
                          @switch (invite.status) {
                            @case (inviteStatuses.Sent) {
                              {{ "INVITE_STATUSES.SENT" | translate }}
                            }
                            @case (inviteStatuses.Rejected) {
                              {{ "INVITE_STATUSES.REJECTED" | translate }}
                            }
                            @case (inviteStatuses.Accepted) {
                              {{ "INVITE_STATUSES.ACCEPTED" | translate }}
                            }
                          }
                        </span>
                      </div>

                      @if (inviteSidebar.canManageEmployees) {
                        <div class="invite-card__actions">
                          @if (invite.status !== inviteStatuses.Accepted) {
                            <button
                              type="button"
                              class="invite-card__action invite-card__action--secondary"
                              (click)="resendInvite(invite.id, invite.recipientEmail)"
                            >
                              {{ "COMPONENTS.EMPLOYEES.ACTIONS.RESEND" | translate }}
                            </button>
                          }
                          <button
                            type="button"
                            class="invite-card__action invite-card__action--danger"
                            (click)="deleteInvite(invite.id)"
                          >
                            {{ "BUTTONS.CANCEL" | translate }}
                          </button>
                        </div>
                      }
                    </article>
                  }
                } @else {
                  <div class="employees-sidebar__empty">
                    {{ "COMPONENTS.EMPLOYEES.EMPTY_INVITES" | translate }}
                  </div>
                }
              </div>
            </app-card-shell>
          </aside>
        }
      }
    </div>
    <app-reusable-modal
      [isOpen]="isInviteModalOpen"
      [panelClass]="'max-w-3xl'"
      [contentScoped]="true"
      [title]="'BUTTONS.INVITE' | translate"
      [subtitle]="'COMPONENTS.EMPLOYEES.INVITE_MODAL.SUBTITLE' | translate"
      (closed)="closeInviteModal()"
    >
      <form class="create-project-form employees-invite-form" [formGroup]="inviteFormModel.form">
        <div class="employees-invite-form__section">
          <label class="form-label" for="invite-recipient-email">
            {{ "TABLE_HEADERS.EMAIL" | translate }}
          </label>
          <input
            id="invite-recipient-email"
            type="email"
            [placeholder]="'PLACEHOLDERS.EMPLOYEE_EMAIL' | translate"
            class="form-input"
            autocomplete="email"
            formControlName="recipientEmail"
          />
          @if (inviteEmailControl.invalid && (inviteEmailControl.touched || inviteEmailControl.dirty)) {
            <p class="employees-invite-form__error">{{ "ERRORS.EMAIL" | translate }}</p>
          }
        </div>

        <div class="employees-invite-form__section">
          <div class="employees-invite-form__section-header">
            <h3>{{ "COMPONENTS.EMPLOYEES.INVITE_MODAL.PERMISSIONS_TITLE" | translate }}</h3>
            <p>{{ "COMPONENTS.EMPLOYEES.INVITE_MODAL.PERMISSIONS_HINT" | translate }}</p>
          </div>

          <div class="employees-invite-form__permissions">
            @for (group of invitePermissionGroups; track group.titleKey) {
              <section class="employees-invite-form__permission-group">
                <h4>{{ group.titleKey | translate }}</h4>

                <div class="employees-invite-form__permission-options">
                  @for (option of group.options; track option.id) {
                    <div class="employees-invite-form__permission-option">
                      <app-checkbox
                        [id]="option.id"
                        [labelText]="option.labelKey | translate"
                        [formControl]="option.control"
                      />
                    </div>
                  }
                </div>
              </section>
            }
          </div>
        </div>

        <div class="create-project-actions employees-invite-form__actions">
          <button type="button" class="form-secondary-btn" (click)="closeInviteModal()">
            {{ "BUTTONS.CANCEL" | translate }}
          </button>
          <button
            type="button"
            class="form-primary-btn"
            [disabled]="inviteFormModel.form.invalid"
            (click)="invite()"
          >
            {{ "BUTTONS.SEND" | translate }}
          </button>
        </div>
      </form>
    </app-reusable-modal>

    @if (selectedEmployeeId) {
      <app-reusable-modal
        [isOpen]="isEmployeeProfileModalOpen"
        [panelClass]="'max-w-4xl employees-profile-modal-panel'"
        [contentScoped]="true"
        [title]="'TITLES.EMPLOYEE_PROFILE' | translate"
        (closed)="closeEmployeeProfileModal()"
      >
        <app-employee-profile
          [id]="selectedEmployeeId"
          [companyId]="companyId"
          [showDeleteButton]="showEmployeeProfileDeleteButton"
          [showPermissions]="showEmployeeProfilePermissions"
          (employeeDeleted)="handleSelectedEmployeeDeleted()"
        />
      </app-reusable-modal>
    }
  </div>
</div>

<app-toasts></app-toasts>

<ng-template #inviteSuccessTpl>
  {{ "MESSAGES.INVITE_SENT" | translate }}
</ng-template>

<ng-template #inviteErrorTpl>
  {{ callbackError }}
</ng-template>
